import { render, staticRenderFns } from "./LandingTermsLogistics.vue?vue&type=template&id=a5fee896"
import script from "./LandingTermsLogistics.vue?vue&type=script&lang=js"
export * from "./LandingTermsLogistics.vue?vue&type=script&lang=js"
import style0 from "./LandingTermsLogistics.vue?vue&type=style&index=0&id=a5fee896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports